import React from "react"
import PropTypes from "prop-types"
import { Button } from "react-weui"

import Ticket from "./Ticket"

class ListTemplate extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { loadAll: false }
  }

  render() {
    const { data, wrapperStyle, containerStyle, firstLoadLength } = this.props
    const justFirstSlice = !!(firstLoadLength > 0 && !this.state.loadAll)

    const dataSlice = (justFirstSlice
      ? data.slice(0, firstLoadLength)
      : data
    )

    return (
      <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
        {
          dataSlice.map(elementInfo => (
            <Ticket
              key={elementInfo.key}
              elementInfo={elementInfo}
              wrapperStyle={wrapperStyle}
              containerStyle={containerStyle}
              onClick={() => elementInfo.onClick()}
              listLength={data.length}
            />
          ))
        }
        {
          justFirstSlice > 0 && (
            <div style={{ padding: "20px 10vw" }}>
              <Button onClick={() => this.setState({ loadAll: true })}>
                {`了解全部（${data.length}）`}
              </Button>
            </div>
          )
        }
      </div>
    )
  }
}

ListTemplate.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  wrapperStyle: PropTypes.object,
  containerStyle: PropTypes.object,
  firstLoadLength: PropTypes.number,
}

ListTemplate.defaultProps = {
  wrapperStyle: {},
  containerStyle: {},
  firstLoadLength: 0,
}

export default ListTemplate



// WEBPACK FOOTER //
// ./src/app/catalogo/components/ListTemplate.jsx